import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { NASProductCategory } from '@websky/graphql';
import { useTheme } from '../../../../theme';
import { GdsAggregationServiceGroup } from '../../../../Checkout/types';
import { getNasServiceCardParams } from '../utils';
import WrappedCommonCard from '../CommonCard/WrappedCommonCard';

interface Props {
	segmentId?: string;
	service: GdsAggregationServiceGroup;
}

const EveryPortLounge: React.FC<Props> = ({ segmentId, service }) => {
	const { t } = useTranslation('Checkout');
	const { t: aasT } = useTranslation('ServiceAggregation');
	const theme = useTheme('CheckoutAdditionalService').Business;

	const params = getNasServiceCardParams(NASProductCategory.lounge);

	return (
		<WrappedCommonCard
			segmentId={segmentId}
			category={NASProductCategory.lounge}
			header={t(params.title)}
			service={service}
			description={t(params.description)}
			coverClassName={theme.business_aggregator}
			icons={params.icons}
		>
			{aasT('Entrance with boarding ticket')}
		</WrappedCommonCard>
	);
};

export default EveryPortLounge;
